
import { mapGetters } from 'vuex';
import { successMessage, errorMessage } from '@/utils/message.js';
import accountInfoService from '../account-info.service.js';
import UploadImage from '@/components/upload-image/index.vue';

export default {
  components: {
    UploadImage
  },
  data () {
    return {
      creditCode: '',
      form: {
        newOrgName: '',
        fileUrl: ''
      },
      confirmTips: '确定要修改农村集体经济组织名称？修改后不可撤销。',
      rules: {
        newOrgName: [
          { required: true, message: '请输入农村集体经济组织名称', trigger: 'blur' }
        ],
        fileUrl: [
          { required: true, message: '请上传农村集体经济组织登记证', trigger: 'change' }
        ]
      }
    };
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  created () {
    this.creditCode = this.$route.query.creditCode;
    if (Number(this.userInfo.type) === 2 || Number(this.userInfo.type) === 4) {
      this.confirmTips = '确定要修改企业名称？修改后不可撤销。';
      this.rules = {
        newOrgName: [
          { required: true, message: '请输入企业名称', trigger: 'blur' }
        ],
        fileUrl: [
          { required: true, message: '请上传营业执照', trigger: 'change' }
        ]
      };
    }
  },
  methods: {
    uploadImage (event) {
      if (event.length > 0) {
        this.form.fileUrl = event[0].sourceImgUrl;
      } else {
        this.form.fileUrl = '';
      }
    },
    submit () {
      let that = this;
      that.$refs['form'].validate(valid => {
        if (valid) {
          that.$confirm(that.confirmTips, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(async () => {
            that.confirmSubmit();
          });
        }
      });
    },
    confirmSubmit () {
      this.$store.commit('OPEN_LOADING');
      accountInfoService.updateCompanyName(this.form).then(res => {
        if (res && res.code === '0') {
          successMessage('提交成功，请等待审核！');
          // this.$store.commit('SET_USER_INFO', {});
          // window.localStorage.clear();
          this.$router.push('/person-center/account-info/member-info');
        } else {
          errorMessage(res.reason);
        }
      }, error => {
        if (error && error.data.reason) {
          errorMessage(error.data.reason);
        } else {
          errorMessage('修改失败');
        }
      });
    }
  }
};
